import apiConfig from "@/config/api";

let ws = null;
let heartbeatTimer = null;
let reconnectTimer = null;
let messageQueue = [];

// 建立连接
function connect() {
  if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING)) {
    console.log("🔗 WebSocket 已连接或正在连接中");
    return;
  }

  const WS_URL = apiConfig.getWebSocketUrl();
  console.log("🚀 正在连接 WebSocket:", WS_URL);
  ws = new WebSocket(WS_URL);

  ws.onopen = () => {
    console.log("✅ WebSocket 连接成功");
    startHeartbeat();

    // 发送队列里的消息
    if (messageQueue.length > 0) {
      messageQueue.forEach(msg => ws.send(msg));
      messageQueue = [];
    }
  };

  ws.onmessage = (event) => {
    if (event.data === "pong") {
      console.log("🏓 收到 pong");
      return;
    }

    try {
      const data = JSON.parse(event.data);
      if (data.type === "pong") {
        console.log("🏓 收到 JSON pong");
        return;
      }
      if (typeof websocket._handleMessage === "function") {
        websocket._handleMessage(data);
      }
    } catch {
      console.warn("收到非 JSON 消息:", event.data);
    }
  };

  ws.onerror = (err) => {
    console.error("⚠️ WebSocket 错误:", err);
    reconnect();
  };

  ws.onclose = () => {
    console.warn("❌ WebSocket 已断开");
    reconnect();
  };
}

// 发送消息
function send(message) {
  const msg = typeof message === "string" ? message : JSON.stringify(message);
  if (ws && ws.readyState === WebSocket.OPEN) {
    ws.send(msg);
  } else {
    console.warn("⚠️ WebSocket 未连接，消息加入队列");
    messageQueue.push(msg);
  }
}

// 开启心跳
function startHeartbeat() {
  clearInterval(heartbeatTimer);
  heartbeatTimer = setInterval(() => {
    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send("ping"); // 或 JSON.stringify({ type: "ping" })
      console.log("❤️ 发送 ping");
    }
  }, 30000); // 每 30 秒发送一次
}

// 自动重连
function reconnect() {
  clearTimeout(reconnectTimer);
  reconnectTimer = setTimeout(() => {
    console.log("🔄 尝试重连 WebSocket...");
    connect();
  }, 5000);
}

// 主动关闭
function close() {
  clearInterval(heartbeatTimer);
  clearTimeout(reconnectTimer);
  if (ws) {
    ws.close();
    ws = null;
  }
}

// 导出模块
const websocket = {
  connect,
  send,
  close,
  _handleMessage: null, // 可被 Vue 注册
};

export default websocket;
